var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path)?_c('router-link',{class:_vm.buttonClass,attrs:{"to":_vm.path ? _vm.path : '/'}},[_vm._v(_vm._s(_vm.buttonText))]):_c('a',{class:_vm.buttonClass},[_vm._v(_vm._s(_vm.buttonText))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b227259","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/elements/ButtonEl.vue
// module id = 98
// module chunks = 6